export default "__VITE_ASSET__JhlKx9x$__"